import { api } from '../../libs/api'
import pagination from './pagination'

export default {
  namespaced: true,

  modules: {
    pagination: pagination(),
  },

  state: {
    index: [],
  },
  mutations: {
    index: (state, index) => {
      const newIndex = index.map((csvFile) => {
        const newCSVFile = Object.assign({}, csvFile)
        newCSVFile.preSignedURL = csvFile.presigned_url
        newCSVFile.fileName = csvFile.file_name
        newCSVFile.fileSize = csvFile.file_size
        newCSVFile.updatedAt = csvFile.updated_at
        return newCSVFile
      })
      state.index = newIndex
    },
  },
  actions: {
    async fetchIndex ({ commit }, query) {
      try {
        const { meta, index } = await api.fetchS3CSVFiles(query)
        commit('pagination/newState', meta)
        commit('index', index)
      } catch (e) {
        return Promise.reject(e)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/csv-file.js